import { createRoutlyAuthClient } from '@routly/ui';

export type { SessionUser } from '@routly/ui';

// The single shared client factory lives in `@routly/ui`; this shim only
// passes the app's own build-time API URL through.
export const authClient = createRoutlyAuthClient(import.meta.env.VITE_API_URL);
